(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const overlay = document.getElementById('menu-overlay');

  const drawer = document.getElementById('drawer-menu');
  const drawerOpener = document.querySelector('.drawer-menu-opener');
  const drawerCloser = document.querySelector('.drawer-menu-closer');

  const cartDrawer = document.getElementById('drawer-cart');
  const cartDrawerOpener = document.querySelector('.drawer-cart-opener');
  const cartDrawerCloser = document.querySelector('.drawer-cart-closer');

  // Function to open the cart
  function openCart() {
    cartDrawer.classList.remove('translate-x-full', 'opacity-0');
    cartDrawer.classList.add('translate-x-0', 'opacity-100');
    overlay.classList.remove('hidden');
    cartDrawerOpener.setAttribute('aria-expanded', 'true');
    cartDrawerCloser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden', 'cart-is-open');
  }

  // Open cart on "add to cart"
  document.addEventListener('liquid-ajax-cart:request-end', (event) => {
    const { requestState } = event.detail;
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      openCart();
    }
  });

  // Function to close the menu
  function closeCart() {
    cartDrawer.classList.add('translate-x-full', 'opacity-0');
    cartDrawer.classList.remove('translate-x-0', 'opacity-100');
    overlay.classList.add('hidden');
    cartDrawerOpener.setAttribute('aria-expanded', 'false');
    cartDrawerCloser.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden', 'cart-is-open');
  }

  // Function to open the menu
  function openMenu() {
    drawer.classList.remove('translate-x-full', 'opacity-0');
    drawer.classList.add('translate-x-0', 'opacity-100');
    overlay.classList.remove('hidden');
    drawerOpener.setAttribute('aria-expanded', 'true');
    drawerCloser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }

  // Function to close the menu
  function closeMenu() {
    drawer.classList.add('translate-x-full', 'opacity-0');
    drawer.classList.remove('translate-x-0', 'opacity-100');
    overlay.classList.add('hidden');
    drawerOpener.setAttribute('aria-expanded', 'false');
    drawerCloser.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  }

  function closeMenuOrCart() {
    if (!drawer.classList.contains('translate-x-full')) {
      closeMenu();
    }
    if (!cartDrawer.classList.contains('translate-x-full')) {
      closeCart();
    }
    return;
  }

  // Event listeners
  drawerOpener.addEventListener('click', openMenu);
  drawerCloser.addEventListener('click', closeMenu);
  cartDrawerOpener.addEventListener('click', openCart);
  cartDrawerCloser.addEventListener('click', closeCart);
  overlay.addEventListener('click', closeMenuOrCart);

  // Close the menu when pressing the "Escape" key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenuOrCart();
    }
  });

  // Open menu on ?open-cart
  function checkOpenCart() {
    // Check if the URL contains ?open-cart
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('open-cart')) {
      // Trigger your custom event or function here
      openCart();
    }
  }

  checkOpenCart();

  window.addEventListener('popstate', checkOpenCart);

  // Dropdowns
  const dropdowns = document.querySelectorAll('.dropdown');

  dropdowns.forEach(function (dropdown) {
    const dropdownTrigger = dropdown.querySelector('.dropdown-trigger');
    const dropdownMenu = dropdown.querySelector('.dropdown-menu');

    if (dropdownTrigger && dropdownMenu) {
      dropdownTrigger.addEventListener('click', function (event) {
        event.preventDefault();

        dropdowns.forEach(function (otherDropdown) {
          const otherDropdownMenu = otherDropdown.querySelector('.dropdown-menu');
          if (otherDropdown !== dropdown && otherDropdownMenu) {
            otherDropdownMenu.classList.remove('max-h-full');
            otherDropdownMenu.classList.add('max-h-0');
            otherDropdownMenu.classList.hidden('max-h-0');
            otherDropdown.classList.remove('active');
          }
        });

        const isDropdownVisible = dropdown.classList.contains('active');

        if (isDropdownVisible) {
          dropdownMenu.classList.remove('max-h-full');
          dropdownMenu.classList.add('max-h-0');
          dropdownMenu.classList.add('hidden');
          dropdown.classList.remove('active');
        } else {
          dropdownMenu.classList.remove('hidden');
          requestAnimationFrame(() => {
            dropdownMenu.classList.add('max-h-full');
            dropdownMenu.classList.remove('max-h-0');
          });
          dropdown.classList.add('active');
        }
      });
    }
  });

  const cartLineItems = document.querySelectorAll('.cart-line-item');

  if (cartLineItems) {
    cartLineItems.forEach(function (cartLineItem) {
      const cartLineItemDeliveryIntervalSelector = cartLineItem.querySelector('.delivery-interval-selector');
      if (cartLineItemDeliveryIntervalSelector) {
        cartLineItemDeliveryIntervalSelector.addEventListener('input', (event) => {
          if (cartLineItemDeliveryIntervalSelector.value == 'one-time') {
            const body = {
              id: cartLineItem.dataset.lineItemKey,
              quantity: cartLineItem.dataset.lineItemQuantity,
              selling_plan: null,
            };
            liquidAjaxCart.change(body);
          } else {
            const body = {
              id: cartLineItem.dataset.lineItemKey,
              quantity: cartLineItem.dataset.lineItemQuantity,
              selling_plan: cartLineItemDeliveryIntervalSelector.value,
            };
            liquidAjaxCart.change(body);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_copy"]) return;
  try {
    
  const overlay = document.getElementById('menu-overlay');

  const drawer = document.getElementById('drawer-menu');
  const drawerOpener = document.querySelector('.drawer-menu-opener');
  const drawerCloser = document.querySelector('.drawer-menu-closer');

  const cartDrawer = document.getElementById('drawer-cart');
  const cartDrawerOpener = document.querySelector('.drawer-cart-opener');
  const cartDrawerCloser = document.querySelector('.drawer-cart-closer');

  // Function to open the cart
  function openCart() {
    cartDrawer.classList.remove('translate-x-full', 'opacity-0');
    cartDrawer.classList.add('translate-x-0', 'opacity-100');
    overlay.classList.remove('hidden');
    cartDrawerOpener.setAttribute('aria-expanded', 'true');
    cartDrawerCloser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden', 'cart-is-open');
  }

  // Open cart on "add to cart"
  document.addEventListener('liquid-ajax-cart:request-end', (event) => {
    const { requestState } = event.detail;
    if (requestState.requestType === 'add' && requestState.responseData?.ok) {
      openCart();
    }
  });

  // Function to close the menu
  function closeCart() {
    cartDrawer.classList.add('translate-x-full', 'opacity-0');
    cartDrawer.classList.remove('translate-x-0', 'opacity-100');
    overlay.classList.add('hidden');
    cartDrawerOpener.setAttribute('aria-expanded', 'false');
    cartDrawerCloser.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden', 'cart-is-open');
  }

  // Function to open the menu
  function openMenu() {
    drawer.classList.remove('translate-x-full', 'opacity-0');
    drawer.classList.add('translate-x-0', 'opacity-100');
    overlay.classList.remove('hidden');
    drawerOpener.setAttribute('aria-expanded', 'true');
    drawerCloser.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
  }

  // Function to close the menu
  function closeMenu() {
    drawer.classList.add('translate-x-full', 'opacity-0');
    drawer.classList.remove('translate-x-0', 'opacity-100');
    overlay.classList.add('hidden');
    drawerOpener.setAttribute('aria-expanded', 'false');
    drawerCloser.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
  }

  function closeMenuOrCart() {
    if (!drawer.classList.contains('translate-x-full')) {
      closeMenu();
    }
    if (!cartDrawer.classList.contains('translate-x-full')) {
      closeCart();
    }
    return;
  }

  // Event listeners
  drawerOpener.addEventListener('click', openMenu);
  drawerCloser.addEventListener('click', closeMenu);
  cartDrawerOpener.addEventListener('click', openCart);
  cartDrawerCloser.addEventListener('click', closeCart);
  overlay.addEventListener('click', closeMenuOrCart);

  // Close the menu when pressing the "Escape" key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenuOrCart();
    }
  });

  // Open menu on ?open-cart
  function checkOpenCart() {
    // Check if the URL contains ?open-cart
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('open-cart')) {
      // Trigger your custom event or function here
      openCart();
    }
  }

  checkOpenCart();

  window.addEventListener('popstate', checkOpenCart);

  // Dropdowns
  const dropdowns = document.querySelectorAll('.dropdown');

  dropdowns.forEach(function (dropdown) {
    const dropdownTrigger = dropdown.querySelector('.dropdown-trigger');
    const dropdownMenu = dropdown.querySelector('.dropdown-menu');

    if (dropdownTrigger && dropdownMenu) {
      dropdownTrigger.addEventListener('click', function (event) {
        event.preventDefault();

        dropdowns.forEach(function (otherDropdown) {
          const otherDropdownMenu = otherDropdown.querySelector('.dropdown-menu');
          if (otherDropdown !== dropdown && otherDropdownMenu) {
            otherDropdownMenu.classList.remove('max-h-full');
            otherDropdownMenu.classList.add('max-h-0');
            otherDropdownMenu.classList.hidden('max-h-0');
            otherDropdown.classList.remove('active');
          }
        });

        const isDropdownVisible = dropdown.classList.contains('active');

        if (isDropdownVisible) {
          dropdownMenu.classList.remove('max-h-full');
          dropdownMenu.classList.add('max-h-0');
          dropdownMenu.classList.add('hidden');
          dropdown.classList.remove('active');
        } else {
          dropdownMenu.classList.remove('hidden');
          requestAnimationFrame(() => {
            dropdownMenu.classList.add('max-h-full');
            dropdownMenu.classList.remove('max-h-0');
          });
          dropdown.classList.add('active');
        }
      });
    }
  });

  const cartLineItems = document.querySelectorAll('.cart-line-item');

  if (cartLineItems) {
    cartLineItems.forEach(function (cartLineItem) {
      const cartLineItemDeliveryIntervalSelector = cartLineItem.querySelector('.delivery-interval-selector');
      if (cartLineItemDeliveryIntervalSelector) {
        cartLineItemDeliveryIntervalSelector.addEventListener('input', (event) => {
          if (cartLineItemDeliveryIntervalSelector.value == 'one-time') {
            const body = {
              id: cartLineItem.dataset.lineItemKey,
              quantity: cartLineItem.dataset.lineItemQuantity,
              selling_plan: null,
            };
            liquidAjaxCart.change(body);
          } else {
            const body = {
              id: cartLineItem.dataset.lineItemKey,
              quantity: cartLineItem.dataset.lineItemQuantity,
              selling_plan: cartLineItemDeliveryIntervalSelector.value,
            };
            liquidAjaxCart.change(body);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundler"]) return;
  try {
    
  function productMediaNavigation(slider) {
    arrowLeft = document.querySelector('.product-media .arrow-left');
    arrowRight = document.querySelector('.product-media .arrow-right');

    function init() {
      arrowLeft.addEventListener('click', () => slider.prev());
      arrowRight.addEventListener('click', () => slider.next());
    }

    slider.on('created', () => {
      init();
    });
  }

  var productMediaSlider = new KeenSlider(
    '#product-media-slider',
    {
      loop: true,
      slides: {
        perView: 1,
      },
      breakpoints: {
        '(min-width: 1024px)': {
          disabled: true,
        },
      },
    },
    [productMediaNavigation]
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  window.location.replace('/?open-cart');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-information"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('.tab-link');
    const sections = document.querySelectorAll('.section-content');

    // Helper to manage active link state
    const setActiveLink = (id, scrollIntoView = true) => {
      links.forEach((link) => {
        const isActive = link.getAttribute('href') === `#${id}`;
        link.classList.toggle('active', isActive);
        link.classList.toggle('border-black', isActive);
        link.classList.toggle('border-transparent', !isActive);

        // Remove focus from all links to avoid :focus conflicts
        if (!isActive) {
          link.blur();
        }
      });
    };

    // IntersectionObserver configuration
    const observer = new IntersectionObserver(
      (entries) => {
        // Get the currently visible entry with the highest intersection ratio
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .reduce((mostVisible, current) => {
            return current.intersectionRatio > (mostVisible?.intersectionRatio || 0) ? current : mostVisible;
          }, null);

        if (visibleEntry) {
          const id = visibleEntry.target.getAttribute('id');
          setActiveLink(id); // Scroll into view when changing active section
        }
      },
      {
        root: null, // Uses the viewport
        rootMargin: '-20% 0px -70% 0px', // Fine-tuned for scrollspy to activate near the top
        threshold: [0.1, 0.5, 0.75], // Activates progressively as visibility increases
      }
    );

    // Observe each section
    sections.forEach((section) => observer.observe(section));

    // Smooth scrolling for links
    links.forEach((link) =>
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          observer.disconnect(); // Disconnect observer before scrolling
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start', // Align the section at the top of the viewport
          });
          setTimeout(() => {
            sections.forEach((section) => observer.observe(section)); // Reconnect observer to all sections after scrolling
            setActiveLink(targetId); // Ensure the active link is visible after scrolling
          }, 1000); // Adjust timeout as needed
        }
      })
    );

    // Ensure the active link is visible on initial load
    const initialActiveLink = document.querySelector('.tab-link.active');
    if (initialActiveLink) {
      initialActiveLink.scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoj-fancy-accordion"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionGroups = document.querySelectorAll('.fancy-accordion');
    let windowWidth = window.innerWidth; // Store the initial window width

    accordionGroups.forEach((group) => {
      const triggers = group.querySelectorAll('.accordion-trigger');
      const panels = group.querySelectorAll('.accordion-panel');
      const progressBars = group.querySelectorAll('.circular-progress__front');
      let currentIndex = 0;
      let intervals = Array(panels.length).fill(null); // Initialize intervals for each panel
      let elapsedTime = 0; // Global elapsed time
      const totalDuration = 6500; // Total duration for progress in milliseconds

      const resetProgress = (index) => {
        progressBars[index].style.strokeDashoffset = '100'; // Reset the progress for the specified index
      };

      const updateProgress = (index) => {
        const progress = Math.max(0, Math.min(100, 100 - (elapsedTime / totalDuration) * 100));
        progressBars[index].style.strokeDashoffset = progress; // Update the progress for the specified index
      };

      const closeOtherPanels = () => {
        panels.forEach((panel, i) => {
          panel.style.maxHeight = '0'; // Collapse all panels
          panel.classList.remove('open', 'active'); // Remove classes
          triggers[i].setAttribute('aria-expanded', 'false');
          resetProgress(i); // Reset progress for closed panels
          clearInterval(intervals[i]); // Clear interval for closed panels
          intervals[i] = null; // Clear reference to the interval
        });
      };

      const openPanel = (panel, index) => {
        closeOtherPanels(); // Close all other panels first
        panel.classList.remove('hidden');
        if (window.innerWidth >= 768) {
          panel.style.opacity = '1'; // Fade in
          panel.style.maxHeight = ''; // Reset max-height if set
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px'; // Expand the panel with animation
        }
        panel.classList.add('open', 'active');
        elapsedTime = 0; // Reset the global elapsed time
        updateProgress(index); // Start the progress for the opened panel
        startInterval(); // Start the interval for the opened panel
        triggers[index].setAttribute('aria-expanded', 'true');
        currentIndex = index; // Update current index
      };

      const switchPanel = () => {
        currentIndex = (currentIndex + 1) % panels.length; // Move to next index
        openPanel(panels[currentIndex], currentIndex); // Open the next panel
      };

      const startInterval = () => {
        clearAllIntervals(); // Clear all existing intervals
        intervals[currentIndex] = setInterval(() => {
          elapsedTime += 100; // Increment elapsed time by 100ms
          updateProgress(currentIndex); // Update the progress for the currently open panel

          // Automatically switch if the total duration is reached
          if (elapsedTime >= totalDuration) {
            switchPanel(); // Switch to the next panel
          }
        }, 100); // Update every 100ms
      };

      const clearAllIntervals = () => {
        intervals.forEach((interval, i) => {
          if (interval) {
            clearInterval(interval); // Clear each interval
            intervals[i] = null; // Clear reference to the interval
          }
        });
      };

      const resetOnResize = () => {
        const newWindowWidth = window.innerWidth;
        if (newWindowWidth !== windowWidth) {
          windowWidth = newWindowWidth; // Update window width

          // Reset all panels and their states
          closeOtherPanels();
          if (currentIndex >= 0) {
            openPanel(panels[currentIndex], currentIndex); // Reopen the current panel
          }
        }
      };

      // Initial setup
      panels.forEach((panel, index) => {
        if (index === 0) {
          openPanel(panel, index); // Open first panel
        } else {
          panel.style.maxHeight = '0'; // Collapse other panels
          triggers[index].setAttribute('aria-expanded', 'false');
        }
        resetProgress(index); // Initialize progress for all panels
      });

      triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', function () {
          const panel = document.getElementById(this.getAttribute('aria-controls'));
          const isExpanded = this.getAttribute('aria-expanded') === 'true';

          // Check if the clicked trigger corresponds to the currently open panel
          if (isExpanded) {
            return; // Do nothing if the panel is already open
          }

          openPanel(panel, index); // Open clicked panel
        });
      });

      // Intersection Observer to manage visibility of the accordion group
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startInterval(); // Start interval when in view
          } else {
            clearAllIntervals(); // Pause all intervals when out of view
          }
        });
      });

      observer.observe(group);

      // Handle window resize
      window.addEventListener('resize', resetOnResize);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoj-section-product-slider_old"]) return;
  try {
    
  var slider = new KeenSlider(
    '#product-slider',
    {
      breakpoints: {
        '(min-width: 678px)': {
          slides: { perView: 3, spacing: 40 },
        },
        '(min-width: 1024px)': {
          slides: { perView: 5, spacing: 24 },
        },
      },
      loop: true,
      initial: 1,
      slides: {
        origin: 'center',
        perView: 2,
        spacing: 16,
      },
    },
    [navigation]
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoj-section-steps_circles"]) return;
  try {
    
  // Select all videos and play buttons
  const videoContainers = document.querySelectorAll('.video-container');

  videoContainers.forEach((container) => {
    const video = container.querySelector('video');
    const playButton = container.querySelector('.play-button');

    playButton.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        container.classList.add('playing');
      } else {
        video.pause();
        container.classList.remove('playing');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
